/**
 * Field formatter - unified formatting system
 */
import { formatCurrency, formatDate, formatNumber, formatPercentage, formatWholePercentage } from "@/lib/intl-formatters";
/**
 * Main field formatter function that formats values based on field configuration
 */
export const formatFieldValue = (value, field) => {
    var _a, _b, _c, _d, _e;
    // Handle null/undefined values
    if (value == null)
        return "-";
    // Custom formatter takes precedence
    if (field.formatter) {
        return field.formatter(value);
    }
    // Get format options from field config
    const options = field.formatOptions || {};
    switch (field.type) {
        case "integer":
            return formatNumber(value, 0);
        case "float":
            return formatNumber(value, (_a = options.maximumFractionDigits) !== null && _a !== void 0 ? _a : 2);
        case "percent":
            return options.percentInputScale === "whole"
                ? formatWholePercentage(value, (_b = options.maximumFractionDigits) !== null && _b !== void 0 ? _b : 2)
                : formatPercentage(value, (_c = options.maximumFractionDigits) !== null && _c !== void 0 ? _c : 2);
        case "currency":
            return formatCurrency(value, (_d = options.currency) !== null && _d !== void 0 ? _d : "EUR", (_e = options.maximumFractionDigits) !== null && _e !== void 0 ? _e : 2);
        case "datetime":
        case "date":
            return formatDate(value, options.dateOptions);
        case "string":
        default:
            return String(value);
    }
};
